import { makeStyles } from "@material-ui/core/styles";

const useEnterpriseInfoModalStyles = makeStyles(() => ({
  /* ---------- existing styles stay as-is ---------- */
  modalWrapper: {
    width: "800px",
    height: "593px",
    backgroundColor: "#1B1D28",
    boxShadow: "0px 19px 45px rgba(0, 0, 0, 0.12)",
    borderRadius: "20px",
    padding: "24px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    color: "#F9F9F9",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingBottom: "16px",
  },

  title: {
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: "24px",
    lineHeight: "36px",
  },
  body: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    flexGrow: 1,
  },
  /* Row with two inputs / dropdowns */
  row: {
    display: "flex",
    gap: "16px",
    width: "100%",
  },

  /* Shared input wrapper */
  inputWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    flex: 1,
  },

  labelRow: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },

  label: {
    fontSize: "14px",
    lineHeight: "21px",
    color: "#B1B5C9",
  },

  required: {
    color: "#E41F1F",
    fontSize: "14px",
    lineHeight: "21px",
  },

  /* TextField root */
  textField: {
    backgroundColor: "#252A38",
    borderRadius: "10px",

    "& .MuiInputBase-root": {
      height: "41px",
      padding: "0 10px",
      color: "#F9F9F9",
      fontSize: "14px",
    },

    "& input::placeholder": {
      color: "#606479",
      opacity: 1,
    },

    "& fieldset": {
      border: "none",
    },
  },

  /* Dropdown field */
  selectField: {
    backgroundColor: "#252A38",
    borderRadius: "10px",

    "& .MuiInputBase-root": {
      height: "41px",
      padding: "0 10px",
      color: "#F9F9F9",
      fontSize: "14px",
    },

    "& .MuiSelect-icon": {
      color: "#F9F9F9",
    },

    "& fieldset": {
      border: "none",
    },
  },

  /* Dropdown menu */
  menuPaper: {
    backgroundColor: "#252A38",
    color: "#F9F9F9",
  },

  menuItem: {
    fontSize: "14px",

    "&:hover": {
      backgroundColor: "#2E3345",
    },
  },

  /* Textarea */
  textAreaWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },

  textArea: {
    backgroundColor: "#252A38",
    borderRadius: "10px",

    "& .MuiInputBase-root": {
      padding: "10px",
      color: "#F9F9F9",
      fontSize: "14px",
      lineHeight: "21px",
    },

    "& textarea::placeholder": {
      color: "#606479",
      opacity: 1,
    },

    "& fieldset": {
      border: "none",
    },
  },
  footer: {
    display: "flex",
    justifyContent: "center",
    paddingTop: "16px",
  },

  submitButton: {
    width: "250px",
    height: "45px",
    backgroundColor: "#6C65D9",
    borderRadius: "10px",
    color: "#F9F9F9",
    textTransform: "none",
    fontSize: "14px",

    "&:hover": {
      backgroundColor: "#6C65D9",
    },
  },
}));

export default useEnterpriseInfoModalStyles;
